import { EventBus } from '@/assets/js/helpers'

export const trackEvent = (event: any) => {
  EventBus.$emit('trackEvent', event)
}
